import { render, staticRenderFns } from "./GenericGridBlock.vue?vue&type=template&id=f640eab6&scoped=true"
import script from "./GenericGridBlock.vue?vue&type=script&lang=js"
export * from "./GenericGridBlock.vue?vue&type=script&lang=js"
import style0 from "./GenericGridBlock.vue?vue&type=style&index=0&id=f640eab6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f640eab6",
  null
  
)

export default component.exports